import { xCheck } from "./xCheck.js";
import { xGetFromToIndex } from "./xGetFromToIndex.js";
export function xAbsoluteSum(array, options = {}) {
    xCheck(array);
    const { fromIndex, toIndex } = xGetFromToIndex(array, options);
    let sum = 0;
    for (let i = fromIndex; i <= toIndex; i++) {
        sum += Math.abs(array[i]);
    }
    return sum;
}
//# sourceMappingURL=xAbsoluteSum.js.map